import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M464 32H48C21 32 0 53 0 80v352c0 27 21 48 48 48h416c27 0 48-21 48-48V80c0-27-21-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z" })
});
export default SvgTable;
